exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".all {\n  padding-bottom: 1em; }\n  .all img {\n    margin-right: .5em; }\n  .all > div {\n    padding: 1em;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-size: 18px;\n    font-weight: 500;\n    border-radius: 9px; }\n    .all > div > a {\n      padding: .5em 2em .5em 2em;\n      margin-top: -.5em;\n      margin-left: .25em;\n      text-decoration: none;\n      color: inherit;\n      border-radius: 3px;\n      float: right;\n      cursor: pointer; }\n\n.element > div {\n  color: #7d6029;\n  background-color: #fcf8e2;\n  border: solid 1px #f8dfa0;\n  white-space: nowrap; }\n  .element > div > a {\n    border: solid 1px #7d6028; }\n\n.element:hover > div {\n  white-space: inherit; }\n\n.general > div {\n  color: #a02e2a;\n  background-color: #f2dede;\n  border: solid 1px #eec2c9;\n  white-space: inherit;\n  padding-top: 1.5em; }\n  .general > div > a {\n    border: solid 1px #a02e2a; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Status/components/SyncPanel/components/scss/errorMessages.scss
// module id = 916
// module chunks = 1